module.exports = __webpack_public_path__ + "img/Tesla Speaker Feature.ce7f3fee.png";